import type { ReactNode } from 'react';
import { ACCENT, FONT_MONO, SURFACE2 } from '../../tokens';

interface SectionLabelProps {
  /** Zero-padded section number, e.g. `"01"`. */
  number: string;
  children: ReactNode;
}

/** Numbered section badge, e.g. `01 / THE PROBLEM`. */
export function SectionLabel({ number, children }: SectionLabelProps) {
  return (
    <div style={{ display: 'inline-block', marginBottom: 32 }}>
      <span
        style={{
          fontFamily: FONT_MONO,
          fontSize: '0.75rem',
          fontWeight: 500,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          background: ACCENT,
          color: SURFACE2,
          padding: '8px 16px',
          borderRadius: 100,
        }}
      >
        {number} / {children}
      </span>
    </div>
  );
}
